import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import * as fromEnvironment from './+state/environment.reducer';
import { EnvironmentEffects } from './+state/environment.effects';
import { EnvironmentFacade } from './+state/environment.facade';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(fromEnvironment.ENVIRONMENT_FEATURE_KEY, fromEnvironment.environmentReducer),
    EffectsModule.forFeature([EnvironmentEffects]),
  ],
  providers: [EnvironmentFacade],
})
export class SharedUtilEnvironmentModule {}
